import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '@/views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '*',
    redirect: '/home'
  },
  {
    path: '/',
    // name: 'home',
    component: HomeView,//首页
    redirect:"/home",
    children:[
      {
        path: '/home',//产品介绍
        name: 'home',
        // 按需加载
        component: () => import( '@/views/home/Home.vue')
      },
      {
        path: '/product',//产品介绍
        name: 'product',
        redirect:"/product/mes",
        // 按需加载
        component: () => import( '@/views/product/product.vue'),
        children:[
          {
            path: '/product/mes',
            name: 'mes',
            // 按需加载
            component: () => import( '@/views/product/ProductSort1.vue')
          },
          {
            path: '/product/ai',
            name: 'ai',
            // 按需加载
            component: () => import( '@/views/product/ProductSort2.vue')
          },
          {
            path: '/product/iot',
            name: 'iot',
            // 按需加载
            component: () => import( '@/views/product/ProductSort3.vue')
          },
          {
            path: '/product/intelligence',
            name: 'intelligence',
            // 按需加载
            component: () => import( '@/views/product/ProductSort4.vue')
          },
        ]
      },
      {
        path: '/resolution',//解决方案
        name: 'resolution',
        // 按需加载
        component: () => import( '@/views/resolution/resolution.vue')
      },
      {
        path: '/service',//服务专区
        name: 'service',
        // 按需加载
        component: () => import( '@/views/service/service.vue')
      },
      // 服务案例servicelist
      {
        path: '/servicelist',//服务专区
        name: 'servicelist',
        // 按需加载
        redirect:"/service/servicelist",
        component: () => import( '@/views/service/serviceList.vue'),
        children:[
          {
            path: '/service/servicelist',
            name: 'servicelist',
            // 按需加载
            component: () => import( '@/views/service/serviceLists.vue'),
          },
          {
            path: '/service/servicedetail',
            name: 'servicedetail',
            // 按需加载
            component: () => import( '@/views/service/serviceListDetail.vue')
          },
        ]
      },
      {
        path: '/news',//新闻资讯
        name: 'news',
        redirect:"/news/newslist",
        // 按需加载
        component: () => import( '@/views/news/news.vue'),
        children:[
          {
            path: '/news/newslist',
            name: 'newslist',
            // 按需加载
            component: () => import( '@/views/news/newsList.vue')
          },
          {
            path: '/news/newsdetail',
            name: 'newsdetail',
            // 按需加载
            component: () => import( '@/views/news/newsDetail.vue')
          },
        ]
      },
      
      {
        path: '/about',//关于我们
        name: 'about',
        // 按需加载
        component: () => import( '@/views/about/about.vue')
      },
    ]
  },
 
]

// [解决 vue-router跳转相同路径报错 ]
const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
const router = new VueRouter({
  routes,
})

export default router
